import { IError } from '@checkout/errors';
import { INotification } from '@checkout/notifications';
import { RootState } from '@checkout/state';
import { Field, Form, Formik, FormikActions, InjectedFormikProps } from 'formik';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormikErrorFocus } from '..';
import { PasswordField } from '..';
import { Button, MembershipHeader, MessageBox, Section } from '../../presentational';
import messages from './../../../i18n/base-en';
import { passwordChangeRequest } from './../../../reducers/checkout';
import * as Styles from './ChangePasswordForm.scss';
import getValidationSchema from './ChangePasswordFormValidationSchema';

interface IOwnProps {}

interface IConnectedProps {
  errors?: IError;
  notifications?: INotification;
}

interface IConnectetDispatchProps {
  passwordChangeRequest: typeof passwordChangeRequest;
}

interface IFormValues {
  password: {
    password: string;
    newPassword: string;
  };
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedFormikProps<IOwnProps, IFormValues> & InjectedIntlProps;

class ChangePasswordForm extends React.Component<Props, {}> {

  validationSchema = () => {
    return getValidationSchema(this.props.intl);
  }

  onSubmit = (values: IFormValues, formikBag: FormikActions<IFormValues>) => {
    this.props.passwordChangeRequest(values.password);
  }

  render() {
    const { errors, notifications, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className={Styles.wrapper}>
        <MembershipHeader
          title={formatMessage(messages.membership_change_password_title)}
          subTitle={formatMessage(messages.membership_change_password_subtitle)}
        />
        {errors && errors.uiType === 'inline' && <MessageBox spacingBottom={true} type="error" message={errors.messages[0]} />}
        {notifications && <MessageBox spacingBottom={true} type={notifications.type} message={notifications.messages[0]} />}
        <Formik<IFormValues, {}>
          initialValues={{
            password: {
              password: '',
              newPassword: '',
            }
          }}
          validationSchema={this.validationSchema}
          onSubmit={this.onSubmit}
          render={(formik) => {
            return (
              <Form className={Styles.form}>
                <Section>
                  <div className={Styles.fields}>
                    <Field
                      id="password.password"
                      name="password.password"
                      component={PasswordField}
                      iconTitle={formatMessage(messages.membership_show_password_tooltip)}
                      placeholder={formatMessage(messages.membership_current_password_placeholder)}
                      label={formatMessage(messages.membership_current_password_label)}
                      required={true}
                      autoComplete="current-password"
                      submitOnEnter={true}
                    />
                    <Field
                      id="password.newPassword"
                      name="password.newPassword"
                      component={PasswordField}
                      iconTitle={formatMessage(messages.membership_show_password_tooltip)}
                      placeholder={formatMessage(messages.membership_new_password_placeholder)}
                      label={formatMessage(messages.membership_new_password_label)}
                      required={true}
                      type="password"
                      autoComplete="new-password"
                      submitOnEnter={true}
                    />
                  </div>
                </Section>

                <div className={Styles.button}>
                  <Button type="submit" variant="primary" align="center" size="medium" width="long" label={formatMessage(messages.membership_save)} />
                </div>

                <FormikErrorFocus formikContext={formik} />
              </Form>
            );
          }}
        />
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      errors: state.checkout.errors,
      notifications: state.checkout.notifications,
    }),
    {
      passwordChangeRequest
    },
  )
)(ChangePasswordForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ChangePasswordForm/ChangePasswordForm.tsx